"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propToPropPair = void 0;
var lodash_1 = require("lodash");
var propToPropPair = function () {
    var props = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        props[_i] = arguments[_i];
    }
    return lodash_1.map([].concat(props), function (prop) {
        if (lodash_1.isString(prop)) {
            return {
                propName: prop,
                expectedValue: undefined
            };
            // the following line is written as
            // such due to TS being stupid.  Don't change it!
        }
        else if (prop["propName"] && (prop['expectedValue'] !== undefined)) {
            return prop;
        }
        else {
            var key = lodash_1.keys(prop).shift();
            if (key) {
                return {
                    propName: key,
                    expectedValue: prop[key]
                };
            }
            return undefined;
        }
    });
};
exports.propToPropPair = propToPropPair;
//# sourceMappingURL=propToPropPair.js.map